import React, { useState, useEffect } from 'react';
import {
  useParams,
  Routes,
  Route,
  Link,
} from 'react-router-dom';
import { Button, Card, Modal } from 'react-bootstrap';
import DataTable from '../../common/components/DataTable';
import PeopleLayout from '../layout/PeopleLayout';
import JobResource from '../../common/resource/JobResource';
import { Icon, LoadingAnimation } from '../../common/components/Utilities';
import JobSelect from '../../common/components/DataSelect/JobSelect';

const formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

function Jobs(props) {
  const content = (
    <Routes>
      <Route path=":id/edit" element={<EditJob />} />

      <Route path=":id?" element={<JobsList />} />
    </Routes>
  );

  return <PeopleLayout {...props} content={content} />;
}

function EditJob() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [job, setJob] = useState();

  const loadJob = async (jobId) => {
    setLoading(true);
    try {
      const jobData = await JobResource.get(jobId);
      setJob(jobData);
    } catch (error) {
      alert('Sorry, failed to load that job.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => loadJob(id), [id]);

  let form;

  if (!loading && job) {
    form = <EditJobForm job={job} />;
  }

  return (
    <Card>
      <Card.Body>
        <LoadingAnimation inline loading={loading} />
        {form}
      </Card.Body>
    </Card>
  );
}

function EditJobForm({ job }) {
  return (
    <form action={`/admin/jobs/${job.id}`} method="POST">
      <input type="hidden" name="_method" value="PUT" />
      <input type="hidden" name="_token" value={window.props.csrfToken} />
      <div className="form-group">
        <label>Public Title</label>
        <input className="form-control" type="text" name="title" defaultValue={job.title} required />
      </div>

      <div className="form-group">
        <label>Internal Title</label>
        <input className="form-control" type="text" name="admin_title" defaultValue={job.admin_title} required />
      </div>

      <div className="form-group">
        <label>Level</label>
        <select className="form-control" name="level" defaultValue={job.level}>
          <option value={null}>N/A</option>
          <option value={1}>1</option>
          <option value={2}>2</option>
          <option value={3}>3</option>
          <option value={4}>4</option>
          <option value={5}>5</option>
          <option value={6}>6</option>
        </select>
      </div>

      <div className="form-group">
        <label>Day Rate</label>
        <input className="form-control" type="text" name="day_rate" defaultValue={job.day_rate} required />
      </div>

      <div className="form-group">
        <label>Parent Role</label>
        <JobSelect name="parent_job_id" value={job.parent_job_id} noneTitle="None" />
      </div>

      <div className="form-group">
        <label>Is Recruiting?</label>
        <select className="form-control" name="is_recruiting" defaultValue={job.is_recruiting}>
          <option value={0}>No</option>
          <option value={1}>Yes</option>
        </select>
      </div>

      <div className="form-group">
        <label>Salary Band (GBP)</label>
        <div className="form-row">
          <div className="col">
            <input className="form-control" type="text" name="salary_band_gbp_min" defaultValue={job.salary_band_gbp_min} />
          </div>
          <div className="col-1 text-center">to</div>
          <div className="col">
            <input className="form-control" type="text" name="salary_band_gbp_max" defaultValue={job.salary_band_gbp_max} />
          </div>
        </div>
      </div>

      <Button type="submit" variant="success">Save Role</Button>
    </form>
  );
}

function JobRow(job) {
  return (
    <tr>
      <td>
        <JobTitle job={job} />
      </td>
      <td>
        {formatter.format(job.day_rate)}
      </td>
      <td>
        {job.users_count}
      </td>
      <td>
        {job.candidates_count}
      </td>
      <td>
        <Link className="btn btn-warning btn-sm" style={{ whiteSpace: 'nowrap' }} to={`/admin/jobs/${job.id}/edit`}>
          <Icon icon="edit" className="mr-2" />
          {' '}
          Edit
        </Link>
      </td>
    </tr>
  );
}

function JobsList() {
  const [modalShow, setShowModal] = useState(false);
  const { id } = useParams();

  return (
    <>
      <div className="mb-4" style={{ textAlign: 'right' }}>
        <Button className="btn btn-success" onClick={() => setShowModal(true)}>Add Role</Button>
      </div>

      <Modal show={modalShow} onClose={() => setShowModal(false)} backdrop="static">
        <Modal.Header>
          Add a new role
        </Modal.Header>
        <form action="/admin/jobs" method="POST">
          <input type="hidden" name="_method" value="POST" />
          <input type="hidden" name="_token" value={window.props.csrfToken} />
          <input type="hidden" name="parent_job_id" value={id} />

          <Modal.Body>
            <div className="form-group">
              <label>Role Title</label>
              <input name="title" className="form-control" type="text" />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" className="btn btn-success">Save Role</Button>
          </Modal.Footer>
        </form>
      </Modal>

      <DataTable url="/resource/jobs" filters={{ parent_id: id }} renderRow={JobRow} columns={['Role', 'Day Rate', 'Users', 'Candidates', '']} />
    </>
  );
}

function JobTitle({ job }) {
  let title = job.admin_title;

  if (job.jobs_count) {
    title = <Link to={`/admin/jobs/${job.id}`}>{job.admin_title}</Link>;
  }

  let subtitle;

  if (job.title !== job.admin_title) {
    subtitle = (
      <span className="ml-2 text-muted">
        (
        {job.title}
        )
      </span>
    );
  }

  return (
    <>
      {title}
      {subtitle}
    </>
  );
}

export default Jobs;
